import { render, staticRenderFns } from "./toast.vue?vue&type=template&id=54990060"
import script from "./toast.vue?vue&type=script&lang=ts"
export * from "./toast.vue?vue&type=script&lang=ts"
import style0 from "./toast.vue?vue&type=style&index=0&id=54990060&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54990060')) {
      api.createRecord('54990060', component.options)
    } else {
      api.reload('54990060', component.options)
    }
    module.hot.accept("./toast.vue?vue&type=template&id=54990060", function () {
      api.rerender('54990060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications/toast.vue"
export default component.exports